import { CarrierPrequalResult } from "../../../powerbroker/src/CarrierPrequalResult";
import { MovementCarrierPay } from "../../../powerbroker/src/MovementCarrierPay";
import { QuickSellDetails } from "../QuickSellDetails";
import { Button, CityState, DataSource, Label, Layout, Panel, StarRating, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutQuickOfferSlideout extends Layout {
    buttonAssignCarrier: Button;
    csEmptyCity: CityState;
    labelAutoRated: Label;
    labelIsoScorecard: Label;
    labelPendingInvite: Label;
    layoutCarrierPrequalResult: CarrierPrequalResult;
    layoutQuickSellDetails: QuickSellDetails;
    lblCarrierContact: Label;
    lblCarrierInfo: Label;
    lblGenInfo: Label;
    lblRates: Label;
    loCarrierPay: MovementCarrierPay;
    panelAssignCarrier: Panel;
    panelBuyToMarket: Panel;
    panelCarrier: Panel;
    panelCarrierInformation: Panel;
    panelComments: Panel;
    panelContact: Panel;
    panelCounterOffer: Panel;
    panelDispatchOffer: Panel;
    panelGeneral: Panel;
    panelIsoScorecard: Panel;
    panelRates: Panel;
    sourceCarrier: DataSource;
    sourceCarrierOffer: DataSource;
    starratingCarrier: StarRating;
    tbCarrierName: Textbox;
    tbComments: Textbox;
    tbContactName: Textbox;
    tbContactPhone: Textbox;
    tbCounterMargin: Textbox;
    tbCounterMarginPrcnt: Textbox;
    tbDispatchMargin: Textbox;
    tbDispatchMarginPrcnt: Textbox;
    tbDotNumber: Textbox;
    tbEmail: Textbox;
    tbMcNumber: Textbox;
    tbMilesToPickup: Textbox;
    tbOfferDate: Textbox;
    tbPayeeId: Textbox;
    tbStatus: Textbox;
    tbTrailerType: Textbox;
    textboxAmount: Textbox;
    textboxBuyToMarket: Textbox;
    textboxBuyToMarketPercent: Textbox;
    textboxCounterOffer: Textbox;
    textboxIntrastateCode: Textbox;
    textboxKpiBouncedBookings: Textbox;
    textboxKpiOnTimeDelivery: Textbox;
    textboxKpiOnTimePickup: Textbox;
    textboxKpiScore: Textbox;
    textboxKpiTotalLoads: Textbox;
}
